export default function MapException(msg) {
    Error.call(this);
    this.name = 'MapException';
    this.message = msg || 'no error message';
}

MapException.prototype = Object.create(Error.prototype);
MapException.prototype.constructor = MapException;
